import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import { createDocumentFolder, updateDocumentFolder } from '../../services/documents';
import type { DocumentFolder } from '../../types';

interface Props {
  open: boolean;
  folder: DocumentFolder | null;
  onClose: () => void;
  onSaved: () => void;
}

export default function FolderDialog({ open, folder, onClose, onSaved }: Props) {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) setName(folder?.name ?? ''); }, [open, folder]);

  const handleSave = async () => {
    if (!name.trim()) return;
    setSaving(true);
    try {
      if (folder) await updateDocumentFolder(folder.id, name.trim());
      else await createDocumentFolder(name.trim());
      onSaved();
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{folder ? 'Rename Folder' : 'New Folder'}</DialogTitle>
      <DialogContent>
        <TextField autoFocus fullWidth value={name} onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleSave()} sx={{ mt: 1 }} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave} disabled={!name.trim() || saving}>Save</Button>
      </DialogActions>
    </Dialog>
  );
}
